import { PayloadAction, createSlice } from '@reduxjs/toolkit';

/**
 * Which base market the list is quoted in. Every market has one or the other,
 * so there is no "all" — showing both at once put the same coin in the table
 * twice at two prices.
 */
export type MarketUnit = 'TMN' | 'USDT';

export interface MarketActionInitialValuesTypes {
  unit: MarketUnit;
  label: string;
}

const initialState: MarketActionInitialValuesTypes = {
  unit: 'TMN',
  label: 'تومان'
};

const market = createSlice({
  name: 'market',
  initialState,
  reducers: {
    changeUnit: (
      state,
      action: PayloadAction<{
        label: string;
        unit: MarketUnit;
      }>
    ) => {
      state.unit = action.payload.unit;
      state.label = action.payload.label;
    }
  }
});

// Action creators are generated for each case reducer function
export const { changeUnit } = market.actions;

export default market.reducer;
